/* eslint-disable func-names */
const CaretManager = function(domInput){
  this.domInput = domInput;
  this.start = domInput.selectionStart;
  this.end = domInput.selectionEnd;
  this.length = this.end - this.start;
  
  const { maxLength } = domInput;

  const getSanitizedPosition = (position) => {
    if(position < 0){
      return 0;
    }

    if(maxLength > 0 && position > maxLength){
      return maxLength;
    }

    return position
  }

  this.moveBy = (start, end) => {
    this.start += start;
    if(typeof end !== 'undefined'){
      this.end += end;
    } else {
      this.end = this.start;
    }

    this.start = getSanitizedPosition(this.start);
    this.end = getSanitizedPosition(this.end);

    this.length = this.end - this.start;
  }

  this.jumpTo = (start, end) => {
    this.start =  getSanitizedPosition(start);
    this.end = getSanitizedPosition(
      typeof end === 'undefined' ? start : end
    );

    this.length = this.end - this.start;
  }

  this.collapse = () => {
    this.end = this.start;
    this.length = 0;
  }
}

export default CaretManager;